import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import './Contact.css';

const Contact: React.FC = () => {
  const { t } = useLanguage();
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };

  const faqData = [
    {
      question: t('contact.faq.q1'),
      answer: t('contact.faq.a1')
    },
    {
      question: t('contact.faq.q2'),
      answer: t('contact.faq.a2')
    },
    {
      question: t('contact.faq.q3'),
      answer: t('contact.faq.a3')
    },
    {
      question: t('contact.faq.q4'),
      answer: t('contact.faq.a4')
    },
    {
      question: t('contact.faq.q5'),
      answer: t('contact.faq.a5')
    },
    {
      question: t('contact.faq.q6'),
      answer: t('contact.faq.a6')
    }
  ];

  return (
    <div className="contact">
      <div className="container">
        <div className="contact-header">
          <h1>{t('contact.title')}</h1>
          <p>{t('contact.subtitle')}</p>
        </div>

        <div className="contact-content">
          {/* Contact Information */}
          <div className="contact-info">
            <div className="info-card whatsapp-card clickable-card" onClick={() => {
              const message = encodeURIComponent(t('contact.whatsapp.message'));
              window.open(`https://wa.me/14073982139?text=${message}`, '_blank', 'noopener,noreferrer');
            }}>
              <div className="info-icon">
                <svg width="2.5rem" height="2.5rem" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.465 3.085"/>
                </svg>
              </div>
              <h3>{t('contact.whatsapp.title')}</h3>
              <p><strong>(407) 398-2139</strong></p>
              <p>{t('contact.whatsapp.subtitle')}</p>
            </div>

            <div className="info-card phone-card clickable-card" onClick={() => {
              window.location.href = 'tel:+14073982139';
            }}>
              <div className="info-icon">📞</div>
              <h3>{t('contact.phone.title')}</h3>
              <p><strong>(407) 398-2139</strong></p>
              <p>{t('contact.phone.hours')}</p>
            </div>

            <div className="info-card email-card clickable-card" onClick={() => {
              window.location.href = 'mailto:cabannasparty@gmail.com?subject=Party Booking Inquiry';
            }}>
              <div className="info-icon">📧</div>
              <h3>{t('contact.email.title')}</h3>
              <p><strong>cabannasparty@gmail.com</strong></p>
              <p>{t('contact.email.response')}</p>
            </div>
          </div>
        </div>

        {/* Service Information Section */}
        <div className="service-info-section">
          <div className="container">
            <div className="service-header">
              <h2>{t('contact.service.title')}</h2>
              <p>{t('contact.service.subtitle')}</p>
            </div>
            <div className="service-cards">
              <div className="info-card service-card">
                <div className="info-icon">📍</div>
                <h3>{t('contact.location.title')}</h3>
                <p><strong>{t('contact.location.area')}</strong></p>
                <p>{t('contact.location.delivery')}</p>
              </div>

              <div className="info-card service-card">
                <div className="info-icon">⏰</div>
                <h3>{t('contact.booking.title')}</h3>
                <p><strong>{t('contact.booking.notice')}</strong></p>
                <p>{t('contact.booking.rush')}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* FAQ Section - Full Width */}
      <div className="faq-section">
        <div className="container">
          <h2>{t('contact.faq.title')}</h2>
          <div className="faq-accordion">
            {faqData.map((faq, index) => (
              <div key={index} className={`faq-item ${openFAQ === index ? 'active' : ''}`}>
                <button
                  className="faq-question"
                  onClick={() => toggleFAQ(index)}
                  aria-expanded={openFAQ === index}
                >
                  <span>{faq.question}</span>
                  <span className={`faq-icon ${openFAQ === index ? 'rotate' : ''}`}>▼</span>
                </button>
                <div className={`faq-answer ${openFAQ === index ? 'open' : ''}`}>
                  <p>{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
